import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

import { ProRataRecovery_s } from "components/recoveries/named-recoveries/named-recoveries-styles"

const Amt = (props: {rowData: [], namedItems: any, field: string, persist: Function}) => {

  const emptyRecord = {
    amt: null,
    amtType: '/Area/Yr',
    increaseNamedItemId: null,
    inflationNamedItemId: null,
    reportTagNamedItemId: null
  }

  const [data, setData] = useState<object|null>(props.rowData['recoverydetail']);

  useEffect(() => {
    if (!props['rowData'] || props['rowData']['recoverydetail']['state'] !== 'amt') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    setData(nextData);
    props.persist({...nextData, state: 'amt'}, 'recoverydetail', props.rowData)
  }

  const inflationOptions = props.namedItems.inflation?.map(inflation => { 
    if (inflation.code) return {label: inflation.code, value: inflation.inflationid} 
  })
  const increaseOptions = props.namedItems.increase?.map(increase => { 
    if (increase.code) return {label: increase.code, value: increase.increaseid} 
  })
  const reportTagOptions = props.namedItems.reportTags?.map(tag => { 
    if (tag.code) return {label: tag.code, value: tag.reporttagid} 
  })

  const attrs = (field) => field_attrs('recovery', 'recoverydetail')(field)(props.rowData, props)

  return (
    <ProRataRecovery_s>
      <SingleRowCarouselState_s>
        <div className="billion-input">
          <label>Amt</label>
          <NumberInput 
            className="automated" 
            data={data} 
            attrs={attrs} 
            field="amt" 
            readPrecision={4} 
            writePrecision={4} 
            min={0} 
            max={1000000000} 
            persist={updateData} 
          />
        </div>   
        <div>
          <label>Amt Type</label>
          <DropdownInput 
            className="automated" 
            data={data} 
            attrs={attrs} 
            field={'amtType'} 
            options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']} 
            persist={updateData} 
          />
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput 
            className="automated" 
            data={data} 
            attrs={attrs} 
            field={'inflationNamedItemId'} 
            options={inflationOptions} 
            persist={updateData} 
          />
        </div>  
        <div>
          <label>Increase</label>
          <DropdownInput 
            className="automated" 
            data={data} 
            attrs={attrs} 
            field={'increaseNamedItemId'} 
            options={increaseOptions} 
            persist={updateData} 
          />
        </div>        
        <div>
          <label>Report Tag</label>
          <DropdownInput 
            className="automated reporttag" 
            data={data} 
            attrs={attrs} 
            field={'reportTagNamedItemId'} 
            options={reportTagOptions} 
            persist={updateData} 
            onClear={() => updateData(null, 'reportTagNamedItemId')}
          />
        </div>   
      </SingleRowCarouselState_s>
    </ProRataRecovery_s>
  )
}

export default Amt
